import React from 'react';
import { useRouteMatch, Link } from 'react-router-dom';
import { get } from 'lodash';
import BoardDetail from 'components/base/BoardDetail';
import { getRecruitment } from 'libs/api/main';
import { useDataApi, useTimezone } from 'libs/hooks';
import { TRecruitment } from 'modules/main';
import { RouteMatch } from 'modules/types';
import { CDateTimeFormat } from 'constants/base.const';
import { ERecruitmentCategory, EOperation } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Spin, Typography, Button, Descriptions } from 'antd';
import { LeftOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';

const { Text, Title } = Typography;
export const RecruitmentViewWrapper = styled.div`
  padding-top: 30px;
  margin: 30px auto 100px auto;
  max-width: 800px;
  .ant-descriptions-item-label {
    background-color: #fff !important;
    width: 30%;
    font-weight: bold;
  }
  .ant-descriptions {
    margin-top: 30px;
  }
  .ant-descriptions-item-content {
    color: #000;
  }
  .small-btn {
    margin-bottom: 10px;
    padding: 0px 10px !important;
  }
  .multi-line {
    white-space: pre-line;
    word-break: break-word;
  }
`;
const CompanyFulltimeView = ({ category }: { category: ERecruitmentCategory }) => {
  const baseUrl =
    category === ERecruitmentCategory.Fulltime ? ERoute.CompanyFulltimeView : ERoute.CompanyTurnOverView;
  const returnUrl =
    category === ERecruitmentCategory.Fulltime ? ERoute.CompanyFulltime : ERoute.CompanyTurnOver;
  const officeLabel = category === ERecruitmentCategory.Fulltime ? '대상 오피스' : '근무 위치';
  const match = useRouteMatch(baseUrl);
  const { record_id } = (match?.params as RouteMatch) || {};
  const [{ data, loading }] = useDataApi<TRecruitment>(getRecruitment.bind(null, record_id));
  const [getDateTime, timezone] = useTimezone();

  return (
    <>
      {category === ERecruitmentCategory.TurnOver ? (
        <RecruitmentViewWrapper className='no-drag'>
          <Link to={returnUrl}>
            <Button className='small-btn'>
              <LeftOutlined />
              목록으로
            </Button>
          </Link>
          <Spin tip='loading...' spinning={loading}>
            <Title level={2}>
              [{get(data, 'company_name')}] {get(data, 'title')}
            </Title>
            <Descriptions size='small' column={1} bordered>
              <Descriptions.Item label='회사명'>{get(data, 'company_name')}</Descriptions.Item>
              <Descriptions.Item label='공고 제목'>{get(data, 'title')}</Descriptions.Item>
              <Descriptions.Item label='홈페이지'>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#000' }}
                  href={get(data, 'website_url')}
                >
                  {get(data, 'website_url')}
                </a>
              </Descriptions.Item>
              <Descriptions.Item label={officeLabel}>{get(data, 'place')}</Descriptions.Item>
              <Descriptions.Item label='채용 직급'>{get(data, 'position')}</Descriptions.Item>
              <Descriptions.Item label='지원 대상'>
                {get(data, 'target') ? get(data, 'target') : '제한없음'}
              </Descriptions.Item>
              <Descriptions.Item label='급여 조건'>{get(data, 'salary')}</Descriptions.Item>
              <Descriptions.Item label='서류 제출 기한'>
                {getDateTime(get(data, 'recruitment_from'))
                  .format(CDateTimeFormat)
                  .replace('PM', '오후')
                  .replace('AM', '오전')}{' '}
                ~&nbsp;
                {get(data, 'recruitment_to') ? (
                  <span>
                    {getDateTime(get(data, 'recruitment_to'))
                      .format(CDateTimeFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                  </span>
                ) : (
                  <span>ASAP</span>
                )}
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='제출 서류'>
                {get(data, 'documents')}
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='지원 방법'>
                {get(data, 'how_to_apply')}
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='채용 과정'>
                {get(data, 'recruitment_process')}
              </Descriptions.Item>
              <Descriptions.Item label='담당자 연락처'>
                <span style={{ color: `${PrimaryColor}` }}>
                  {get(data, 'responsible_name')},&nbsp;
                  <a style={{ color: `${PrimaryColor}` }} href={`mailto:${get(data, 'responsible_email')}`}>
                    {get(data, 'responsible_email')}
                  </a>
                </span>
              </Descriptions.Item>
              <Descriptions.Item label='기타'>
                <div
                  className='paragraph-no-margin'
                  dangerouslySetInnerHTML={{ __html: `${get(data, 'etc')}` }}
                />
              </Descriptions.Item>
            </Descriptions>
          </Spin>
        </RecruitmentViewWrapper>
      ) : (
        <BoardDetail
          operation={EOperation.View}
          pathName={ERoute.CompanyFulltime}
          record={data}
          loading={loading}
          useFile={false}
          useThumbnail={true}
        />
      )}
    </>
  );
};

export default CompanyFulltimeView;
